// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2dZJf","footer":"ModalUpdate_footer__eNPV4"};